import { createAction } from "redux-actions";

export const SETTING_DETAIL = "SETTING_DETAIL";
export const settingDetails = createAction(SETTING_DETAIL);

export const UPDATE_SETTING = "UPDATE_SETTING";
export const updateSetting = createAction(UPDATE_SETTING);
